import Collection from './collection';

export default Collection;
